export const COMMUNITY_ID = "communityId";
export const SELECTION_CRITERIA = "selectionCriteria";
export const DATE_RANGE = "dateRange";
export const YEAR = "year";

export const MONTHLY = "monthly";
export const YEARLY = "yearly";

export const selectionCriteriaOptions = [
  { value: MONTHLY, label: "Monthly" },
  { value: YEARLY, label: "Yearly" },
];

export const lineItemColumnOptions = [
  { key: "postingDate", label: "Posting Date", checked: true },
  { key: "documentDate", label: "Document Date", checked: true },
  { key: "documentNumber", label: "Document Number", checked: true },
  { key: "lineNumber", label: "Line item id", checked: true },
  { key: "documentType", label: "Doc Type", checked: true },
  { key: "itemText", label: "Line item text", checked: true },
  { key: "debitAmount", label: "Debits", checked: true },
  { key: "creditAmount", label: "Credits", checked: true },
  { key: "costCenter", label: "Cost Center", checked: false },
  { key: "postingPeriod", label: "Posting Period", checked: false },
  { key: "currency", label: "Currency", checked: false },
  { key: "reference", label: "Reference", checked: false },
];